export var BUTTON_CLICK = "BUTTON_CLICK";
export var DROPDOWN_CLICK = "DROPDOWN_CLICK";
export var DROPDOWN_ITEM_CLICK = "DROPDOWN_ITEM_CLICK";

//# sourceMappingURL=analytics.js.map